import script from "./PromiseButton.vue?vue&type=script&lang=js"
export * from "./PromiseButton.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__